import CaShippingLabelWIndow from './CaShippingLabelWIndow';
import { withI18n } from 'react-i18next';

export default CaShippingLabelWIndow;
